import React from 'react';
import { Box, Button, Container, HomeIcon, Typography } from "../../styles/MaterialUI";
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
    const navigate = useNavigate();

    const handleHomeButton = () => {
        navigate("/home");
    }
    return (
        <Container
            sx={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '90vh', textAlign: 'center',
            }}
        >
            <Box sx={{ mb: 4 }}>
                <Typography variant="h1" color="error">404</Typography>
                <Typography variant="h6" color="textSecondary">Page Not Found</Typography>
            </Box>
            <Button variant="contained" color="primary" startIcon={<HomeIcon />} onClick={handleHomeButton} sx={{ textTransform: "none" }}>Go to Home</Button>
        </Container>
    )
}

export default PageNotFound;
